import React, { FC, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useScmSaleRoDetailModel } from "../scmSaleRoModel";
import { Description } from "@/components/YhBox/Description";
import { Button } from 'antd';

export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
    const { lookRoFormVal: { returnCode, status, customerName }, getTreeNodeName } = useScmSaleRoDetailModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const orderStatu: IDescription[] = [
        {
            label: "销售退货单",
            value: returnCode,
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "客户",
            value: customerName,
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
        />
    )
}